// extracted by mini-css-extract-plugin
export var alertIcon = "_nj-0";